import CryptoJS from "crypto-js";

var encryptionKey = process.env.REACT_APP_ENCRYPTION_KEY;

const encrypt = (myDataObj, encryption_key = process.env.REACT_APP_ENCRYPTION_KEY) => {
  const myData = JSON.stringify(myDataObj,);

  try {
    const enData = CryptoJS.AES.encrypt(myData, encryption_key).toString();
    // console.log("encrypted:", enData);
    return enData;
  } catch (err) {
    // console.log(err);
  }
};

const decrypt = (myData) => {
  try {
    var decryptedData = CryptoJS.AES.decrypt(myData, encryptionKey);

    var decryptedDataParsed = JSON.parse(
      decryptedData.toString(CryptoJS.enc.Utf8)
    );
    // console.log("decrypted:", decryptedDataParsed);
  } catch (err) {
    // console.log(err);
  }

  return decryptedDataParsed;
};

export { encrypt, decrypt };